module.exports = __webpack_public_path__ + "img/loading.bd66fe25.svg";